// CARO. Casa de estilo — the style tests' routes (docs/plan-tests-y-servicios.md): the Estudio de estilo
// at /estudio-de-estilo (docs/plan-estudio-estilo.md, fase 0: one root for every interactive page) with
// the three games, each with one page per result. One language per URL like the
// rest of the site (ES root, /en, /fr, segments translated in lib/seo/routes.ts); a language answers only
// when it is listed in COLORIMETRY_LOCALES (its copy is in place), otherwise a real 404 (Worker pageMeta
// and the client pages). Everything under the old /colorimetry-me and /tests-de-estilo answers a one-hop
// 301 here (worker/lib/localeRedirect.ts).

import type { Locale } from '@/types';

/** The home of the Estudio de estilo: the three tests today (indexable). */
export const STUDIO_PATH = '/estudio-de-estilo';

/** COLORIMETRY ME! (docs/plan-colorimetry-me.md): indexable, in the sitemap with its 12 season pages. */
export const COLORIMETRY_PATH = `${STUDIO_PATH}/colorimetria`;

/**
 * The guide «Combinar colores» (docs/plan-estudio-p1-guia.md, fase 3): the rules and, per season, its
 * neutrals, metals, contrast and four combinations (lib/studio/guide.ts). Indexable, in the sitemap; one
 * anchor per season (the season's slug in that language).
 */
export const GUIDE_PATH = `${STUDIO_PATH}/combinar-colores`;

/**
 * «Mi estudio» (docs/plan-estudio-p2-muneco.md): your doll (season, silhouette, face, skin, hair, eyes)
 * carried in the URL (`?p=`, DOLL_PARAM). Personal, so `noindex,follow`, out of the sitemap and llms.txt.
 */
export const MY_STUDIO_PATH = `${STUDIO_PATH}/mi-estudio`;

/** The query parameter of the doll (lib/studio/doll.ts). Here, light, so GA can strip it without the doll's data. */
export const DOLL_PARAM = 'p';

/** Languages the games answer in (docs/plan-colorimetry-me-i18n.md). */
export const COLORIMETRY_LOCALES: readonly Locale[] = ['es', 'en', 'fr'];

export const COLORIMETRY_TITLE = 'COLORIMETRY ME!';

export function colorimetryAvailable(locale: Locale): boolean {
  return COLORIMETRY_LOCALES.includes(locale);
}

/**
 * P2 (docs/plan-colorimetry-me-p2.md): the silhouette and face games, each with one page per result
 * (lib/colorimetry/styleSlugs.ts). SEO-ready (meta, #root, BreadcrumbList, sitemap entries) but held
 * `noindex` and out of the sitemap while STYLE_INDEXABLE is false. Published (index + sitemap + links from
 * the colour game) by the owner on 2026-10-23.
 */
export const SILHOUETTE_PATH = `${STUDIO_PATH}/morfologia`;
export const FACE_PATH = `${STUDIO_PATH}/forma-de-cara`;
export const STYLE_INDEXABLE = true;

/** Where the games lived until 2026-10-23 and 2026-10-26 (logical paths): now one-hop 301s to the paths above. */
export const LEGACY_COLORIMETRY_PATH = '/colorimetry-me';
